export default "__VITE_ASSET__rkxYXqLr__"